import React from "react";
import { SearchContent } from "./SearchContent/SearchContent";
import { ModalConstructor } from "../ModalConstructor";

export function ContentSearchModal({
    groupIds,
    onClose,
    open,
}: {
    groupIds: number[];
    onClose: () => void;
    open: boolean;
}) {
    const handleClose = () => {
        onClose?.();
    };

    const modalConstructorOpts = {
        onClose: handleClose,
        open: open,
        modalContent: (
            <SearchContent groupIds={groupIds} closeSearchModal={handleClose} />
        ),
        modalInnerContainerStyles: {
            overflowY: "unset",
            height: "calc(100vh - 24px)",
            maxWidth: "640px",
            borderRadiusTopLeft: "12px",
            borderRadiusTopRight: "12px",
            "@media (min-width: 640px)": {
                borderRadius: "12px",
            },
            "& .MuiDialogContent-root": {
                padding: "0",
            },
            "& .MuiDialogActions-root": {
                justifyContent: "flex-start",
                "& > :not(:first-of-type)": {
                    marginLeft: 0,
                },
            },
            "& .MuiDialogTitle-root": {
                margin: 0,
                padding: "12px 16px",
                borderBottom: "1px solid var(--community-color-dark-gray)",
            },
        },
    };

    return <ModalConstructor {...modalConstructorOpts} />;
}
